import React from 'react';
import { motion } from 'framer-motion';
export function ProofSection() {
  return <section className="py-24 px-4 bg-brand-accent text-white overflow-hidden relative" data-id="element-160">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10" style={{
      backgroundImage: 'radial-gradient(circle at 2px 2px, white 1px, transparent 0)',
      backgroundSize: '32px 32px'
    }} data-id="element-161"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-162">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-163">
          <h2 className="text-3xl md:text-4xl font-serif mb-12 leading-tight" data-id="element-164">
            En solo 7 días usando este sistema, una familia promedio de 4
            personas:
          </h2>

          <div className="grid md:grid-cols-2 gap-8 md:gap-12" data-id="element-165">
            <div className="bg-white/10 backdrop-blur-md p-8 rounded-3xl border border-white/20" data-id="element-166">
              <div className="text-6xl md:text-7xl font-bold font-serif mb-2" data-id="element-167">
                Ahorra
              </div>
              <div className="text-5xl md:text-6xl font-black text-yellow-300 mb-4 tracking-tighter" data-id="element-168">
                $120
              </div>
              <p className="text-lg text-white/90 font-medium" data-id="element-169">
                dólares en comida rápida
              </p>
            </div>

            <div className="bg-white/10 backdrop-blur-md p-8 rounded-3xl border border-white/20" data-id="element-170">
              <div className="text-6xl md:text-7xl font-bold font-serif mb-2" data-id="element-171">
                Recupera
              </div>
              <div className="text-5xl md:text-6xl font-black text-yellow-300 mb-4 tracking-tighter" data-id="element-172">
                5 hrs
              </div>
              <p className="text-lg text-white/90 font-medium" data-id="element-173">
                de tiempo libre que antes perdían cocinando y lavando
              </p>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}